import React from 'react'
import { Row } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { i18nTranslate, enablePdpRedesign } from 'src/utils'
import { APPConfig, getBuyNowInPDP } from 'config/appConfig'
import { productDeps } from 'src/deps'
import './styles.scss'

@observer
class ProductItemId extends React.Component {
  render() {
    const product = this.props
    let skuId = product?.skuId || ''
    let productId = product?.productId || ''
    let itemSize = product?.size || ''
    const enableNewPDPStyle =
      APPConfig?.getAppConfig()?.enableNewPDPStyle === 'true'

    /*todo SSR locale*/
    const isPbomProduct = productDeps.isPbomProduct(product)
    let textForDisplay = enableNewPDPStyle
      ? product.isBundle
        ? i18nTranslate('pdp.itemCode', 'Item', {
            nameSpace: 'ssr-resource',
          }) +
          ': ' +
          productId
        : i18nTranslate('override_text_price_sku', 'SKU', {
            nameSpace: 'ssr-resource',
          }) +
          ': ' +
          skuId
      : i18nTranslate('pdp.itemCode', 'Item', {
          nameSpace: 'ssr-resource',
        }) +
        ' # ' +
        skuId
    if (isPbomProduct) {
      textForDisplay = i18nTranslate('pdp.sku', 'Sku') + ': ' + productId
    }
    const textCaseClassName = enableNewPDPStyle
      ? product.isBundle
        ? 'text-capitalize'
        : 'text-uppercase'
      : 'text-capitalize'

    if (this.props?.isExpressPDP && !getBuyNowInPDP()) {
      return null
    }

    const renderSkuIdSize = () => {
      return (
        <Row noGutters className="align-items-center" tabIndex={0}>
          <div className="d-flex align-items-center">
            {product?.sku && itemSize && (
              <p className="product-sku-id product-size-margin">{itemSize}</p>
            )}
            <h2 className="product-sku-id text-uppercase" data-testid="Item#">
              {textForDisplay}
            </h2>
          </div>
        </Row>
      )
    }

    const renderSkuId = () => {
      return (
        <Row noGutters className="flex-column" tabIndex={0}>
          <h2
            className={`itemno heading-5 ${textCaseClassName}`}
            data-testid="Item#">
            {textForDisplay}
          </h2>
          {product?.sku && itemSize && (
            <p className="product-size-near-id paragraph-m">{itemSize}</p>
          )}
        </Row>
      )
    }

    return enablePdpRedesign() ? renderSkuIdSize() : renderSkuId()
  }
}

export { ProductItemId }
